/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  DevicesImportControllerExportCsvV2Params,
  DevicesImportControllerExportCsvV2PathParameters,
  DevicesImportControllerExportDeviceCsvV2PathParameters,
  DevicesImportControllerImportCsvV2Body,
  DevicesImportControllerImportCsvV2Params,
  DevicesImportControllerImportCsvV2PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DevicesCsvV2Service {
  private readonly http = inject(HttpClient);
  /**
   * CSV export
   * @summary Export devices CSV
   */

  exportCsv<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesImportControllerExportCsvV2PathParameters,
    params?: DevicesImportControllerExportCsvV2Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices/export`, {
      params: (() => {
        const objectParamStrategies: Readonly<Record<string, 'flatten' | 'comma' | 'deepObject'>> = { filters: 'flatten' };

        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (
            value != null &&
            typeof value === 'object' &&
            !Array.isArray(value) &&
            Object.prototype.hasOwnProperty.call(objectParamStrategies, key)
          ) {
            const objectStrategy = objectParamStrategies[key];
            const entries = Object.entries(value as Record<string, unknown>);
            if (objectStrategy === 'comma') {
              const commaParts: string[] = [];
              for (const [prop, propValue] of entries) {
                if (Array.isArray(propValue)) {
                  const filteredItems = propValue.filter(
                    item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
                  ) as Array<string | number | boolean>;
                  if (filteredItems.length) {
                    commaParts.push(prop, ...filteredItems.map(String));
                  }
                } else if (
                  propValue != null &&
                  (typeof propValue === 'string' || typeof propValue === 'number' || typeof propValue === 'boolean')
                ) {
                  commaParts.push(prop, String(propValue));
                }
              }
              if (commaParts.length) {
                filteredParams[key] = commaParts.join(',');
              }
            } else {
              for (const [prop, propValue] of entries) {
                const targetKey = objectStrategy === 'deepObject' ? key + '[' + prop + ']' : prop;
                if (Array.isArray(propValue)) {
                  const filteredProp = propValue.filter(
                    item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
                  ) as Array<string | number | boolean>;
                  if (filteredProp.length) {
                    filteredParams[targetKey] = filteredProp;
                  }
                } else if (
                  propValue != null &&
                  (typeof propValue === 'string' || typeof propValue === 'number' || typeof propValue === 'boolean')
                ) {
                  filteredParams[targetKey] = propValue;
                }
              }
            }
            continue;
          }
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * CSV export for a single device (same format as bulk export; import-compatible)
   * @summary Export device CSV
   */

  exportDeviceCsv<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesImportControllerExportDeviceCsvV2PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices/${deviceId}/export`);
  }
  /**
   * CSV import (SuperAdmin). Pass buildingId, floorId, roomId as query params.
   * @summary Import devices CSV
   */

  importCsv<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesImportControllerImportCsvV2PathParameters,
    devicesImportControllerImportCsvV2Body: DevicesImportControllerImportCsvV2Body,
    params: DevicesImportControllerImportCsvV2Params,
  ): Observable<TData> {
    const formData = new FormData();
    formData.append(`file`, devicesImportControllerImportCsvV2Body.file);

    return this.http.post<TData>(`/devices/v2/clients/${clientId}/devices/import`, formData, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
